import { EMPTY_STRING, MONEY_SYMBOL, COMMA_SYMBOL } from 'modules/core/constants';

export const costFormattedStringToNumber = (str?: string): number =>
  Number(str?.replace(MONEY_SYMBOL, EMPTY_STRING).replace(COMMA_SYMBOL, EMPTY_STRING)) || 0;
